"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const svgs_1 = require("@@/assets/svgs");
function default_1() {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '10px',
            border: '0.5px solid rgba(0, 0, 0, 0.1)',
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            pointerEvents: 'none',
        } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.LockerIconWhiteSvg, {}) })));
}
exports.default = default_1;
